// extracted by mini-css-extract-plugin
module.exports = {"container":"Detail_container_gjytS","chevron":"Detail_chevron_13npQ","usersTable":"Detail_usersTable_1lHLo"};